module.exports = __webpack_public_path__ + "img/PE.45b647f8.png";